import React from 'react';
import moment from 'moment';
import { BadgeAlt, DataTableColumnHeader, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import { titleize } from 'underscore.string';
import { booleanFormatter, defaultFormatter, } from 'components/design-system/molecules/formatters';
import TariffTypes from '../TariffTypes';
import { TARIFF_SERVICE_TYPES } from '../TariffServiceTypes';
const MARKETS_VISIBLE = 2;
function MarketsCell({ markets }) {
    if (!(markets === null || markets === void 0 ? void 0 : markets.length)) {
        return React.createElement("span", { className: "text-muted-foreground" }, '—');
    }
    const visible = markets.slice(0, MARKETS_VISIBLE);
    const overflow = markets.length - visible.length;
    return (React.createElement("div", { className: "flex flex-wrap items-center gap-1" },
        visible.map((m) => (React.createElement(BadgeAlt, { key: m, variant: "secondary" }, m))),
        overflow > 0 && (React.createElement(TooltipProvider, null,
            React.createElement(Tooltip, null,
                React.createElement(TooltipTrigger, { asChild: true },
                    React.createElement("span", { className: "cursor-default" },
                        React.createElement(BadgeAlt, { variant: "outline" }, `+${overflow}`))),
                React.createElement(TooltipContent, null,
                    React.createElement("div", { className: "max-w-xs whitespace-normal" }, markets.join(', '))))))));
}
function EffectiveDateCell({ value }) {
    if (!value)
        return React.createElement("span", { className: "text-muted-foreground" }, '—');
    return React.createElement("span", null, moment(value).format('MM/DD/YYYY'));
}
const TYPE_LABELS = TariffTypes.reduce((acc, tt) => {
    acc[tt.value] = tt.name;
    return acc;
}, {});
const SERVICE_TYPE_LABELS = TARIFF_SERVICE_TYPES.reduce((acc, st) => {
    acc[st.value] = st.name;
    return acc;
}, {});
export function getTariffsColumns({ t, }) {
    return [
        {
            accessorKey: 'name',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('NAME') })),
            cell: ({ row }) => React.createElement("span", null, row.original.name),
            size: 220,
        },
        {
            accessorKey: 'type',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('TYPE') })),
            cell: ({ row }) => {
                var _a;
                return (React.createElement("span", null, (_a = TYPE_LABELS[row.original.type]) !== null && _a !== void 0 ? _a : defaultFormatter(row.original.type)));
            },
            size: 140,
        },
        {
            accessorKey: 'markets',
            header: () => React.createElement("span", null, titleize(t('MARKET', { count: 2 }))),
            cell: ({ row }) => React.createElement(MarketsCell, { markets: row.original.markets || [] }),
            enableSorting: false,
            size: 180,
        },
        {
            accessorKey: 'service_type',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('SERVICE_TYPE') })),
            cell: ({ row }) => {
                var _a;
                const value = row.original.service_type;
                if (!value)
                    return React.createElement("span", { className: "text-muted-foreground" }, '—');
                return React.createElement("span", null, (_a = SERVICE_TYPE_LABELS[value]) !== null && _a !== void 0 ? _a : value);
            },
            size: 140,
        },
        {
            accessorKey: 'effective_start_date',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Effective Start Date" })),
            cell: ({ row }) => (React.createElement(EffectiveDateCell, { value: row.original.effective_start_date })),
            size: 160,
        },
        {
            accessorKey: 'effective_end_date',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: "Effective End Date" })),
            cell: ({ row }) => (React.createElement(EffectiveDateCell, { value: row.original.effective_end_date })),
            size: 160,
        },
        {
            accessorKey: 'is_default',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('DEFAULT_FOR_MARKET') })),
            cell: ({ row }) => booleanFormatter(row.original.is_default),
            size: 160,
        },
        {
            accessorKey: 'numberOfShippers',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('OF_ASSIGNED_SHIPPERS'), className: "justify-end" })),
            cell: ({ row }) => {
                var _a;
                return (React.createElement("div", { className: "text-right" }, (_a = row.original.numberOfShippers) !== null && _a !== void 0 ? _a : 0));
            },
            size: 160,
        },
    ];
}
